import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Flex, Box, Icon } from '@qga/roo-ui/components';

const FlagChildren = styled(Box)`
  flex: 1 1 auto;
  align-self: center;
`;

export const Flag = ({ icon, iconSize, children, ...rest }) => {
  return (
    <Flex {...rest}>
      <Box>{icon && <Icon name={icon} mr="2" size={iconSize} />}</Box>
      <FlagChildren>{children}</FlagChildren>
    </Flex>
  );
};

Flag.propTypes = {
  icon: PropTypes.string,
  iconSize: PropTypes.string,
  children: PropTypes.node.isRequired,
};

Flag.defaultProps = {
  icon: '',
  iconSize: '',
};
